import * as ACTION_TYPES from '../types';

let initialState = {
  tenantsList: [],
  tenant: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

    case ACTION_TYPES.ADD_TENANT:
      return {tenantsList: action.data };

      case ACTION_TYPES.GET_TENANTS:
        return {...state, tenantsList: action.data };
      
      case ACTION_TYPES.DELETE_TENANT:
        let newList = state.tenantsList.filter(tenant => tenant._id !== action.id);
        return {...state, tenantsList: newList };
      
      case ACTION_TYPES.GET_TENANT_BY_ID:
        return {...state, tenant: action.data};

        case ACTION_TYPES.GET_TENANTLIST_BY_ID:
        return {...state, tenantsList: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_TENANTS:
        return {...state, tenantsList: []};

        case ACTION_TYPES.GET_TENANT_BY_Query:
          return {...state, tenantsList: action.data};

      default:
        return state;
    }
  };